import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationPlamsConstants {
    static STEP_TITLE = "Location";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static COPY_OWNER_LABEL = "Copy owner to applicant";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property you are lodging an application for by using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Note that multiple properties may be added. ";
    static DESCRIPTION_LABEL_4 = "If this is an application for a lease, draw an area (polygon) around the lease area on the map.";
    static DESCRIPTION_LABEL_5 = "Owner details should be added for each property (this is linked to the property and the application).";
    static PROPERTY_REQUIRED = "Note that you need to select a property before continuing with the create application process";
    static PROPERTY_ID_CONTROL = "propId";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ZONING_CONTROL = "zoning";
    static STREET_NO_CONTROL = "streetNumber";
    static STREET_NAME_CONTROL = "streetName";
    static TOWN_CONTROL = "town";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static ZONE_CONTROL = "zone";
    static OWNER_CONTROL = "owners";
    static APPLICATION_TYPE_CONTROL = "applicationType";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ZONING_TEXT_PLACEHOLDER = "Zoning";
    static STREET_NO_TEXT_PLACEHOLDER = "Street number";
    static STREET_NAME_TEXT_PLACEHOLDER = "Street name";
    static TOWN_TEXT_PLACEHOLDER = "Town";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static APPLICATION_TYPE_PLACEHOLDER = "Application type";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static LAYER_REF = "Property and lease graphics";
    static NO_PROPERTIES_SELECTED_MESSAGE = "At least one property must be selected before a lease area is drawn";
    static LEASE_AREA_EXISTS_MESSAGE = "A lease area has already been captured for this application";
    static LEASE_AREA_OUTSIDE_SELECTED_PROPERTY_MESSAGE = "The lease area(s) drawn are outside the extent of the selected property";
    static DRAW_POLYGON_LABEL = "Please draw an area (polygon) around the lease area on the map.";
    static POLYGON_DRAWN_LABEL = "Lease area selected.";
    static NO_OWNERS_SELECTED_MESSAGE = "Please select an owner to copy to applicant";
    static MULTIPLE_OWNERS_SELECTED_MESSAGE = "Multiple owners have been selected, please select only one to copy to applicant";
    static COPY_OWNER_TO_APPLICANT_SUCCESS_MESSAGE = "Owner successfully copied to applicant";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        town: {
            required: `Town ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zoning: {
            required: `Zoning ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        streetNumber: {
            required: `Street number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        streetName: {
            required: `Street name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        application: {
            required: `Application ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
